import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth';
import CoreuiVue from '@coreui/vue';
import VueLocalStorage from 'vue-localstorage';

// eslint-disable-next-line import/extensions
import App from './App';
import router from './router/index';
import { iconsSet as icons } from './assets/icons/icons.js';
import store from './store/index';
import { getAuthOptions } from './bootstrap/auth';
import { initFilters } from './filters/init';
import { initSocket } from './bootstrap/socket';

Vue.router = router;

initFilters();
const socket = initSocket({ Vue, store });

Vue.use(VueLocalStorage);
Vue.use(VueAxios, axios);
Vue.use(VueAuth, getAuthOptions({ store, socket, localStorage: Vue.localStorage }));
Vue.use(CoreuiVue);

new Vue({
  el: '#app',
  router,
  store,
  // CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  components: {
    App,
  },
  template: '<App/>',
});
